import { render, staticRenderFns } from "./ChainTaskDetailsModal.vue?vue&type=template&id=04aebcba&scoped=true"
import script from "./ChainTaskDetailsModal.vue?vue&type=script&lang=js"
export * from "./ChainTaskDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ChainTaskDetailsModal.vue?vue&type=style&index=0&id=04aebcba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aebcba",
  null
  
)

export default component.exports